import React from 'react';
import TagsUrlInputWrapper from './TagsUrlInputWrapper';
import PropTypes from 'prop-types';
import CommonTagsInputWrapper from './CommonTagsInputWrapper';

class InforEamTagsUrlInputWrapper extends React.Component {
  getTagLink = tagValue => {
    return window.REACT_APP_INFOR_EAM_URL_PATH + this.props.inforEamUrlSuffix + tagValue;
  };

  render() {
    return <CommonTagsInputWrapper {...this.props} urlTagLink={this.getTagLink} />;
  }
}

InforEamTagsUrlInputWrapper.propTypes = {
  inforEamUrlSuffix: PropTypes.string.isRequired,
};

export default InforEamTagsUrlInputWrapper;
